import { render, staticRenderFns } from "./EquipamentoSensorForm.vue?vue&type=template&id=fc165dce&scoped=true&"
import script from "./EquipamentoSensorForm.vue?vue&type=script&lang=js&"
export * from "./EquipamentoSensorForm.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoSensorForm.vue?vue&type=style&index=0&id=fc165dce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc165dce",
  null
  
)

export default component.exports